<template>
  <wc-dialog
    :showDialog='showDialog'
    :title="(entryCopy.id ? 'Edit ' : 'Add ') + 'Entry'"
    :icon='$store.state.icons.modules.timesheets.icon'
    :iconColor='$store.state.icons.modules.timesheets.iconColor'
    :disableButtons='!isFormValid'
    :loadingButtons='isLoading'
    @cancel="$emit('cancel')"
    @save="saveEntry"
    saveText='Save Entry'
    width='550'
  >
    <template v-slot:dialog-actions v-if='payrollEntry'>
      <v-btn text color='red' @click='confirmDelete = true'>Delete Entry</v-btn>
    </template>

    <v-form v-model='isFormValid' ref='form'>
      <v-alert
        v-if='entry.date !== today'
        border='top'
        icon='mdi-alert'
        colored-border
        type='error'
        class='pb-2 red lighten-5'
      >
        <span class='body-2 font-weight-bold pt-0'>Not Today's Entry</span>
      </v-alert>

      <span :class='titleClass'>
        {{ getNameDisplay(entry.employee) }}
      </span>
      <br v-if="$vuetify.breakpoint.smAndDown">
      <span :class='subtitleClass'>
        {{ entry.date | longDate }}
      </span>

      <v-row>
        <v-col cols='12' sm='6'>
          <wc-timepicker
            label='Started'
            increment='15'
            start='5'
            end='23'
            required
            prependIcon='mdi-timer-outline'
            v-model='entryCopy.start'
          ></wc-timepicker>
        </v-col>

        <v-col cols='12' sm='6'>
          <wc-timepicker
            label='Finished'
            increment='15'
            start='5'
            end='23'
            required
            prependIcon='mdi-timer-off-outline'
            v-model='entryCopy.end'
          ></wc-timepicker>
        </v-col>

        <v-col cols='12' sm='6'>
          <v-btn
            block depressed
            :color="entryCopy.had_lunch ? 'success' : 'error'"
            @click='entryCopy.had_lunch = !entryCopy.had_lunch'
          >
            <v-icon left>
              {{entryCopy.had_lunch ? 'mdi-food' : 'mdi-food-off'}}
            </v-icon>
              {{ entryCopy.had_lunch ? 'Had Lunch' : 'No Lunch'}}
          </v-btn>
          <br>
          <v-btn block dark depressed color='purple' @click='setDayOff'>Didn't work this day</v-btn>
        </v-col>

        <v-col cols='12' sm='6'>
          <v-card-text class='text-h5 text-center pt-1'>
            {{ hoursWorked + ' hrs - ' + (entryCopy.had_lunch ? 'took lunch' : 'no lunch') }}
          </v-card-text>

          <v-text-field
            class='pt-0'
            dense
            label="KMs"
            v-model='entryCopy.kms'
            :rules='[rules.decimalOrEmpty]'
            hint='max 3 digits'
          ></v-text-field>
        </v-col>
        <v-col cols='12'>
          <v-textarea
            v-if='entryCopy.kms'
            height='120px'
            outlined
            class='mt-0 pt-0'
            label="KMs Notes"
            v-model='entryCopy.kms_notes'
          ></v-textarea>
        </v-col>
      </v-row>
    </v-form>
  </wc-dialog>
</template>

<script>
import timesheetsServices from '../services/timesheets'
import timesheetsAPI from '../api/timesheets'
import formRules from '@/mixins/formRules'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'entry-basics-dialog',
  mixins: [formRules],
  props: {
    entry: {
      required: true
    },
    showDialog: {
      required: true,
      type: Boolean,
      default: false
    },
    payrollEntry: {
      required: false,
      type: Boolean,
      default: false
    },
    profiles: {
      required: false,
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    isFormValid: false,
    isLoading: false,
    entryCopy: {kms: 0},
  }),
  mounted () {

  },
  computed: {
    hoursWorked () {
      return timesheetsServices.hoursWorked(this.entryCopy)
    },
    today () {
      return moment().format('YYYY-MM-DD').toString()
    },
    titleClass () {
      if (this.$vuetify.breakpoint.xs) {
        return 'headline info--text font-weight-light text-uppercase'
      }
      return 'display-1 info--text font-weight-light text-uppercase'
    },
    subtitleClass () {
      if (this.$vuetify.breakpoint.xs) {
        return 'title grey--text font-weight-light'
      }
      return 'headline grey--text font-weight-light'
    }
  },
  watch: {
    'showDialog' () {
      if (this.showDialog) {
        this.entryCopy = _.cloneDeep(this.entry)
      }
    }
  },
  methods: {
    async saveEntry () {
      this.isLoading = true
      let tmp = {}
      this.entryCopy.hours_worked = this.hoursWorked
      if (this.entryCopy.id) {
        this.entryCopy.hours_left_to_assign = await timesheetsServices.updateEntryHoursLeft(this.entryCopy)
        tmp = await timesheetsAPI.updateTimesheetEntry(this.entryCopy)
        if (this.entryCopy.end === this.entryCopy.start) {
          this.$emit('returnToDashboard')
        } else {
          this.$emit('saved', tmp)
        }
      } else {
        this.entryCopy.hours_left_to_assign = this.hoursWorked
        tmp = await timesheetsAPI.createTimesheetEntry(this.entryCopy)
        if (this.entryCopy.end === this.entryCopy.start) {
          this.$emit('returnToDashboard')
        } else if (this.payrollEntry) {
          this.$emit("openEntry", tmp)
        } else {
          this.$router.push({ name: 'TimesheetEntry', params: { id: tmp.id } })
        }
      }
      this.isLoading = false
    },
    setDayOff() {
      // OPTIONAL FEATURE 
      // need to add conditional here to check if there's been any hours assigned already.  and if so, warn the user that you're about to delete them.
      // then call timesheetServices.deleteAllDetails(entryID) (after you build it)
      this.entryCopy.end = this.entryCopy.start
      this.entryCopy.had_lunch = false
      this.entryCopy.hours_left_to_assign = 0
      this.saveEntry()
    },
    getNameDisplay(employeeID) {
      // this logic can likely be simplified/improved (when time permits) - MJ
      if (this.profiles.length && this.entry.employee) {
        return _.find(this.profiles, p => p.id === employeeID).name_display
      } else if (this.entry.employee_obj) {
        return this.entry.employee_obj.name_display
      } else if (this.entry.employee === this.$store.state.auth.profile.id) {
        return this.$store.state.auth.profile.name_display
      }
      return 'error - profile not found'
    }
  }
}
</script>
